/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";

const { checkLocalStorage, bindLocalStorage } = useLocalStorage();

const formObject = {
  accountName: {
    value: null,
    error: null,
  },
  bsbNumber: {
    value: null,
    error: null,
  },
  accountNumber: {
    value: null,
    error: null,
  },
  
};

export const useDepositFormStore = defineStore({
  id: "depositForm",
  state: () => ({
    form: checkLocalStorage("depositForm", formObject),
  }),
  getters: {
    formHasErrors: (store) => {
      const errors = Object.entries(store.form).filter((e) => {
        // Check inside each object in the state for the error String.
        const field = e[1];
        return Object.getOwnPropertyDescriptor(field, "error")
          ? field.error !== "" && field.error !== undefined
          : "";
      });
      return errors.length > 0;
    },
  },

  actions: {
    updateValue(field, val) {
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
    updateError(field, error) {
      this.form[field].error = error;
      bindLocalStorage(this.$id, this.form);
    },
  },
});
